import React from 'react'

import { List, Table, useMediaQueryContext, useModalContext } from '@fourthwall/components'
import type { Offer } from '@fourthwall/services/dist/models/offer'

import { ExplicitSellingPriceListItem } from '../ExplicitSellingPriceListItem'
import type { SizeVariantSellingPriceModalFormValues } from '../SizeVariantSellingPriceModal'
import { SizeVariantSellingPriceModal } from '../SizeVariantSellingPriceModal'
import type { ExplicitSellingPriceProps } from './types'

export const ExplicitSellingPrice = ({
  data,
  tableHeaders,
  isCompareAtPriceEnabled,
  applyToAllVariants,
  disabled,
}: ExplicitSellingPriceProps) => {
  const media = useMediaQueryContext()
  const { open } = useModalContext()

  const handleSubmit =
    (size: Offer.Variant['size']) => (values: SizeVariantSellingPriceModalFormValues) => {
      applyToAllVariants({
        priceValue: values.price.value.toString(),
        compareAtPriceValue: values.compareAtPrice?.value
          ? values.compareAtPrice?.value.toString()
          : null,
        size,
      })
    }

  const openModal = (offerVariant: Offer.Variant) => {
    if (disabled) return

    open(SizeVariantSellingPriceModal, {
      offerVariant,
      isCompareAtPriceEnabled,
      onSubmit: handleSubmit(offerVariant.size),
    })
  }

  if (!media.tablet) {
    return (
      <List
        data={data}
        renderItem={(offerVariant: Offer.Variant) => (
          <ExplicitSellingPriceListItem offerVariant={offerVariant} />
        )}
        onClick={openModal}
      />
    )
  }

  return <Table data={data} headers={tableHeaders} minWidth={0} />
}
